/** Resolve Aria API base URL for browser builds (login + axios). */
export function resolveApiBase() {
  if (process.env.REACT_APP_API_URL) {
    return String(process.env.REACT_APP_API_URL).replace(/\/$/, "");
  }
  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    if (host === "localhost" || host === "127.0.0.1") {
      return "http://127.0.0.1:3014";
    }
  }
  return "https://api.aria-institute.com";
}

export default resolveApiBase;
